module.exports = __webpack_public_path__ + "static/media/change_status_1.70b56df6.png";